import { Select, type SelectProps } from '@mantine/core'
import React from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreItemPriceRuleDurationUnit } from '@flecto/types'

export function SelectTypeDurationUnit(props: Omit<SelectProps, 'data'>) {
  const { t } = useTranslation('saas', { keyPrefix: 'item-form' })

  const typeData: { label: string; value: CoreItemPriceRuleDurationUnit }[] = [
    {
      label: `${t('row.day')}(s)`,
      value: 'days',
    },
    {
      label: `${t('row.hour')}(s)`,
      value: 'hours',
    },
  ]

  return <Select {...props} data-cy='step2-price_rule' data={typeData} />
}
